module.exports = __webpack_public_path__ + "img/证书4.14375a64.jpg";